"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initArticlesSlider = exports.initTestimonialSlider = exports.initFeatureSlider = void 0;
var RemSlider_1 = require("@/api/browser/RemSlider");
var initFeatureSlider = function () {
    var initSlider = function () {
        var element = document.getElementById('soleagentproperties');
        RemSlider_1.default(element);
    };
    document.addEventListener("DOMContentLoaded", initSlider);
    document.addEventListener("resize", initSlider);
};
exports.initFeatureSlider = initFeatureSlider;
var initTestimonialSlider = function (iniIndex) {
    var initSlider = function () {
        var element = document.getElementById('testimonial');
        RemSlider_1.default(element, iniIndex);
    };
    document.addEventListener("DOMContentLoaded", initSlider);
    document.addEventListener("resize", initSlider);
};
exports.initTestimonialSlider = initTestimonialSlider;
var initArticlesSlider = function () {
    var initSlider = function () {
        var element = document.getElementById('articles');
        RemSlider_1.default(element);
    };
    document.addEventListener("DOMContentLoaded", initSlider);
    document.addEventListener("resize", initSlider);
};
exports.initArticlesSlider = initArticlesSlider;
